import { useState } from "react";

import { useRecord } from "@latticexyz/stash/react";
import mudConfig from "contracts/mud.config";
import { stash } from "../../../mud/stash";
import { useSessionPlayer } from "../../../SessionPlayerContext";

import MainButton from "../../../components/MainButton";

import { hasBeenMoreThanADay } from "../../../utils";

import { gameStates } from "../../../config.js";

export const StateSelector = ({onSelect}) => {  
  const { address: userAddress } = useSessionPlayer();

  const player = (userAddress) ? useRecord({
    stash, 
    table: mudConfig.tables.Player, 
    key: { counterValue: userAddress } 
  }) : false;

  const playerTimes = (player && userAddress) ? useRecord({
    stash,
    table: mudConfig.tables.PlayerTimes,
    key: { counterValue: userAddress }
  }) : false;

  const isInitiallyRollTimeout = (playerTimes)
    ? 
      !hasBeenMoreThanADay( 
        new Date().getTime(), 
        parseInt( playerTimes.lastRoll ) * 1000 
      )
    :
      false;

  const [gameState, setGameState] = useState( gameStates.HOME );

  const playerHasSeed = (player) ? !!player?.currentSeedNumbers[0] : false;
  const playerHasWritten = (player) ? !!player?.hasWritten : false;

  return <>
      <MainButton 
        disabled={ gameState === gameStates.READ}
        name={`To the Story Doors`} 
        onClick={() => {
          setGameState( gameStates.READ );
          onSelect( gameStates.READ );
        }
      }/>
      <MainButton 
        disabled={ 
          ( !playerHasSeed && gameState === gameStates.ROLL) 
          || (isInitiallyRollTimeout && !playerHasSeed ) 
          || (playerHasSeed && gameState === gameStates.WRITE) 
        }
        name={`To the Library`} 
        onClick={() => {
          if( isInitiallyRollTimeout || playerHasSeed ){
            setGameState( gameStates.WRITE );
            onSelect( gameStates.WRITE );
          } else {
            setGameState( gameStates.ROLL );
            onSelect( gameStates.ROLL );
          }
        }}/>
      {(playerHasWritten) ? <MainButton 
        disabled={ 
          gameState === gameStates.INN        
        }
        name={`To the Inn`} 
        onClick={() => {
          setGameState( gameStates.INN );
          onSelect( gameStates.INN );
      }}/> : ''}
  </>
}